module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/info_image@1x.6f930c0.png";